import { Container, ContainerGutter, Richtext } from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaDisclaimerTextLegal } from '../ui/hucha-disclaimer-text-legal';
import { HuchaDisclaimer2StandardText } from './hucha-disclaimers';

interface DisclaimerContentProps {
	fontSize?: string;
	showDisclaimerNumber?: boolean;
	textGutter?: ContainerGutter;
}

export const HuchaDisclaimer2StandardContent = ({
	fontSize,
	showDisclaimerNumber = true,
	textGutter = ContainerGutter.static350,
}: DisclaimerContentProps): React.JSX.Element => {
	return (
		<Container wrap={'always'} gutter={textGutter}>
			<HuchaDisclaimerTextLegal fontSize={fontSize}>
				{showDisclaimerNumber && '2. '}
				<Richtext dangerouslyParseRawHTML markdown={HuchaDisclaimer2StandardText} />
			</HuchaDisclaimerTextLegal>
		</Container>
	);
};
